import { render, staticRenderFns } from "./apprList.vue?vue&type=template&id=9adef52e&scoped=true&"
import script from "./apprList.vue?vue&type=script&lang=js&"
export * from "./apprList.vue?vue&type=script&lang=js&"
import style0 from "./apprList.vue?vue&type=style&index=0&id=9adef52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adef52e",
  null
  
)

export default component.exports